import React from 'react';
import Chart from 'react-apexcharts';

export const ApexChart = ({ options }) => {
  return (
    <Chart
      options={options}
      series={options?.series || []}
      type={options?.chart?.type || 'area'}
      height={options?.chart?.height || 400}
    />
  );
};

